import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'Context/QueryClientContext';
import ObrasApi from 'Data/Obras.api';
import { IObraResponse } from 'Data/interfaces/Obra/IObraListResponse';
import toastHandler from 'Utils/toastHandler';
import { OBRA_QUERY_KEY } from 'Data/keys/QueryKeys';
import { IRestoreSADisciplineRequest } from 'Data/interfaces/Obra/ISolutionSADisciplineRequest';
import { DisciplineFolderStatusEnum } from 'Data/interfaces/Obra/IDisciplineResponse';

export const useQueryRestoreDisciplineSA = () => {
  const { mutate, isPending } = useMutation({
    mutationFn: (variables: IRestoreSADisciplineRequest) => {
      return ObrasApi.restoreSADiscipline(variables.ConstructionSiteDisciplinesId);
    },
    onMutate: async (variables) => {
      const previousObras = queryClient.getQueryData<IObraResponse[]>(
        [OBRA_QUERY_KEY],
      );
      const previousUniqueObra = queryClient.getQueryData<IObraResponse>(
        [OBRA_QUERY_KEY, Number(variables.ConstructionSiteId)],
      );

      queryClient.setQueryData<IObraResponse[]>([OBRA_QUERY_KEY],
        (old) => {
          return old?.map((obra) => {
            if (
              obra.ConstructionSiteId === variables.ConstructionSiteId &&
              obra.Disciplines && obra.Disciplines.length > 0
            ) {
              const index = obra.Disciplines.findIndex((discipline: any) => {
                return discipline.ConstructionSiteDisciplinesId === variables.ConstructionSiteDisciplinesId;
              });
              if (index !== -1) {
                obra.Disciplines[index].FolderStatus = DisciplineFolderStatusEnum.Sync;
              }
            }
            return obra;
          });
        },
      );
      queryClient.setQueryData<IObraResponse>(
        [OBRA_QUERY_KEY, Number(variables.ConstructionSiteId)],
        (old) => {
          if (old && old.Disciplines && old.Disciplines.length > 0) {
            const index = old.Disciplines.findIndex((discipline: any) => {
              return discipline.ConstructionSiteDisciplinesId === variables.ConstructionSiteDisciplinesId;
            });
            if (index !== -1) {
              old.Disciplines[index].FolderStatus = DisciplineFolderStatusEnum.Sync;
            }
          }
          return old;
        },
      );

      // TODO: invalidar chave da listagem de arquivos para essa disciplina

      return { previousObras, previousUniqueObra };
    },
    onError: async (error: any, variables, context) => {
      await Promise.all([
        queryClient.cancelQueries({ queryKey: [OBRA_QUERY_KEY] }),
        queryClient.cancelQueries({ queryKey: [OBRA_QUERY_KEY, Number(variables.ConstructionSiteId)] }),
      ]);

      queryClient.setQueryData<IObraResponse[]>(
        [OBRA_QUERY_KEY],
        context?.previousObras,
      );
      queryClient.setQueryData<IObraResponse>(
        [OBRA_QUERY_KEY, Number(variables.ConstructionSiteId)],
        context?.previousUniqueObra,
      );

      const errorMsg = error.errors
        ? error.errors[0].Message
        : 'Erro ao restaurar disciplina';
      toastHandler.showError(errorMsg);
    },
  });

  return {
    restoreDisciplineSA: mutate,
    isLoading: isPending,
  };
};
